import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  HostListener,
} from '@angular/core';
import { distinctUntilChanged, debounceTime, takeUntil } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Rx';


@Component({
  selector: 'app-autocomplete-search',
  template: require('./autocomplete-search.component.html'),
  styles: [require('./autocomplete-search.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteSearchComponent implements OnInit, OnChanges, OnDestroy {
  @Input() items = [];
  @Input() searchBy = 'name';
  @Input() isLoading: boolean;
  @Input() disabled: boolean;
  @Input() inputPlaceholder: string;
  @Input() resultTemplate: TemplateRef<any>;
  @Output() searched = new EventEmitter<string>();
  @Output() selected = new EventEmitter<object>();
  originalItems: object[];
  input = '';
  searchInput = '';
  searchUpdated = new Subject<string>();
  searchSubscription: Subscription;
  searchVisible = false;
  isInputFocused = false;

  private destroy$ = new Subject();

  ngOnInit() {
    this.initializeDebounceForSearch();
  }

  ngOnChanges(changes: SimpleChanges) {
    const { items } = changes;

    if (items) {
      this.originalItems = cloneDeep(this.items);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSearchType(value: string) {
    this.searchInput = value;

    this.isLoading = true;

    this.toggleSearch();
    this.searchUpdated.next(value);
  }

  public showSearch(): void {
    this.searchVisible = true;
  }

  public toggleSearch(): void {
    if (this.input) {
      this.showSearch();
    } else {
      this.hideSearch();
    }
  }

  public hideSearch() {
    this.searchVisible = false;
    this.isInputFocused = false;
  }

  public onItemSelect({ item }) {
    this.input = '';
    this.onInputsChange();

    this.selected.emit(item);
    this.hideSearch();
  }

  private onSearchInput() {
    if (this.input) {
      this.onInputsChange();
    }
  }

  private onInputsChange() {
    this.searched.emit(this.input);
  }

  private initializeDebounceForSearch() {
    this.searchSubscription = this.searchUpdated
      .pipe(
        debounceTime(100),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      )
      .subscribe(() => this.onSearchInput());
  }

  /**
   * Listens for Escape and Tab key presses to close the dropdown
   *
   * @param {KeyboardEvent} event
   * @memberof AutocompleteSearchComponent
   */
  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Tab') {
      this.hideSearch();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/autocomplete-search/autocomplete-search.component.ts